(function utilityBar($) {
  const MOBILE_MAX_WIDTH = 767; // < 768px
  const INTERVAL_MS = 4000;

  const initCarousel = ($container) => {
    const $items = $container.find('li');
    if ($items.length <= 1) return null;

    let index = 0;
    $items.hide().attr('aria-hidden', 'true');
    $items.eq(index).show().attr('aria-hidden', 'false');

    return setInterval(() => {
      const $current = $items.eq(index);
      index = (index + 1) % $items.length;
      const $next = $items.eq(index);

      $current.stop(true, true).fadeOut(200, () => {
        $current.hide();
        $next.stop(true, true).fadeIn(200).attr('aria-hidden', 'false');
      }).attr('aria-hidden', 'true');
    }, INTERVAL_MS);
  };

  const destroyCarousel = ($container) => {
    const data = $container.data('utilityCarousel');
    if (data && data.intervalId) {
      clearInterval(data.intervalId);
      $container.removeData('utilityCarousel');
    }
    const $items = $container.find('li');
    $items.stop(true, true).show().attr('aria-hidden', 'false');
  };

  const maybeToggle = ($wrap) => {
    const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
    const $list = $wrap.find('.utility-bar-inner > ul');
    if (!$list.length) return;

    if (isMobile) {
      // Initialize only once
      const data = $list.data('utilityCarousel');
      if (!data) {
        const intervalId = initCarousel($list);
        $list.data('utilityCarousel', { intervalId });
      }
    } else {
      destroyCarousel($list);
    }
  };

  $(() => {
    $('.utility-bar').each((_, el) => {
      const $wrap = $(el);
      maybeToggle($wrap);

      // debounce resize
      let resizeTimer;
      $(window).on('resize.utilityBar', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { maybeToggle($wrap); }, 150);
      });
    });
  });
}(jQuery));
